import { RequestService } from './../../services/request.service';
import { WfRequest } from './../../models/request';
import { Component, OnInit } from '@angular/core';

import { NbComponentStatus, NbToastrService } from '@nebular/theme';
import { listKeyitem } from '../../../../../shared/Models/SelectItems';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'app-create-request',
  templateUrl: './create-request.component.html',
  styleUrls: ['./create-request.component.scss'],
})
export class CreateRequestComponent implements OnInit {
  data: listKeyitem[] = [];
  request: WfRequest = {} as WfRequest;

  constructor(private service: RequestService, private toaster: NbToastrService) {}

  ngOnInit() {
    this.loadRequiredData();
  }
  loadRequiredData() {
    this.service.getCreateNew().subscribe(resp => (this.data = resp));
  }
  startRequest() {
    this.request.ownerUserId = this.service.userId;
    this.service.post(this.request).subscribe(resp => {
      const position = 'bottom-right';
      this.showToast(position, 'بدأ الطلب بنجاح', 'success');
    });
  }
  showToast(position, message, status: NbComponentStatus) {
    this.toaster.show(message, '', { position, status });
  }
}
